import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {I18n, TranslationObject} from '@colonist/i18n'
import {StringUtils} from '@colonist/utils'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {Sound} from '../Sound'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {createOptionIn, createSelectIn, setElementOnClick} from '../ui_utils/DomUtils'
import {ViewPopup} from './ViewPopup'
import {clientIntl, replaceLanguageInPath} from '../ClientI18n'
import {StorageWrapper} from '../StorageWrapper'

export class ViewPopupLanguage extends ViewPopup {
    private readonly supportedLanguages: string[]
    private readonly currentLanguage: string
    private selectedLanguage: string

    constructor() {
        const changeLanguagePopupTitle: TranslationObject = {key: 'strings:homePage.footer.changeLanguagePopupTitle'}
        const changeLanguagePopupBodyKey: TranslationObject = {key: 'strings:homePage.footer.changeLanguagePopupBody'}
        super(changeLanguagePopupTitle, changeLanguagePopupBodyKey, () => undefined, () => undefined, true)
        this.supportedLanguages = I18n.languages
        this.currentLanguage = UIUtilsEjsVariables.language
        this.createLanguageSelect()
        setElementOnClick(this.checkButton, () => void this.setLanguage())
        this.body.classList.add('language-popup')
        this.removeXButton()
        this.show()
    }

    private createLanguageSelect() {
        const languageSelect = createSelectIn(this.body, '', '', (value: string) => this.selectedLanguage = value)
        this.supportedLanguages.forEach((languageCode: string) => {
            const languageName = clientIntl.getLanguageName(languageCode)
            if(languageName == undefined) return
            const languageNameCapitalized = StringUtils.capitalizeFirstLetter(languageName)
            const nativeLanguageName = clientIntl.getLanguageName(languageCode, languageCode)
            if(nativeLanguageName == undefined) return
            const nativeLanguageNameCapitalized = StringUtils.capitalizeFirstLetter(nativeLanguageName)
            const displayName = `${languageNameCapitalized} (${nativeLanguageNameCapitalized})`
            createOptionIn(languageSelect, languageCode, {key: 'strings:colonistCommon.utils.#buffer', options: {value: displayName}})
        })
        languageSelect.selectedIndex = this.supportedLanguages.indexOf(this.currentLanguage)
        this.selectedLanguage = languageSelect.value
    }

    private async setLanguage() {
        Sound.playSound(Sound.SoundType.Click)
        this.removePopup()
        StorageWrapper.setLanguage(this.selectedLanguage)
        if(this.selectedLanguage == this.currentLanguage) return
        const dataToSend = {language: this.selectedLanguage} as AjaxDataTypes.LanguageChangeData
        await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSetUserLanguage(), undefined, dataToSend, 'application/json')

        window.location.pathname = replaceLanguageInPath(window.location.pathname, this.selectedLanguage)
    }
}
